import store from '../../redux/store';

/**
 * Add permission here
 *
 */
export const PERMISSIONS = {
	COMPANY: {
		ADD_USER_TO_COMPANY: 'ADD_USER_TO_COMPANY',
		CREATE_BRANDSPACE: 'CREATE_BRANDSPACE',
		DELETE_BRANDSPACE: 'DELETE_BRANDSPACE',
		EDIT_BRANDSPACE: 'EDIT_BRANDSPACE',
		FONT_UPLOAD: 'FONT_UPLOAD'
	}
};


/**
 * Map permission to property in redux store.
 *
 */
const permissionMap = {
	//[P9052-11604] admins should be able to edit their users before subscribing
	[PERMISSIONS.COMPANY.ADD_USER_TO_COMPANY]: ({ company }) => true, 
	[PERMISSIONS.COMPANY.CREATE_BRANDSPACE]: ({ company }) => company.isActive,
	[PERMISSIONS.COMPANY.DELETE_BRANDSPACE]: ({ company }) => company.isActive,
	[PERMISSIONS.COMPANY.EDIT_BRANDSPACE]: ({ company }) => company.isActive,
	[PERMISSIONS.COMPANY.FONT_UPLOAD]: ({ company }) => company.isActive
};

/**
 * Get context from redux store.
 *
 * @returns {{company: *}}
 */
function createContext() {
	const { companies: { selectedId, rawDataById } } = store.getState();

	return {
		company: rawDataById[selectedId]
	};
}

/**
 * Check if feature is available for user.
 *
 * @param feature
 * @returns {*}
 */
export const hasFeature = ({ feature }) => {
	if (!feature || !permissionMap[feature]) {
		return undefined;
	}

	return permissionMap[feature](createContext());
};



// WEBPACK FOOTER //
// ./src/components/Features/index.js